import React, { useState } from 'react'
import './index.sass';
import {SelectButton} from '../common/Button'



export default function GenderButton({ mIcon, mActiveIcon, mText, fIcon, fActiveIcon, fText, handleClick }) {
    const [mIsActive, setmIsActive] = useState(false);
    const [fIsActive, setFIsActive] = useState(false);

    const mHandleButtonClick = () => {
        setmIsActive(true);
        setFIsActive(false);

        handleClick(0);

    }
    const fHandleButtonClick = () => {
        setFIsActive(true);
        setmIsActive(false);

        handleClick(1);
    }
    
    return (
        <div className="lover-gender-btn-gp">
            <div className="lover-app-gender-wrapper">
                <SelectButton icon={mIcon} activeIcon={mActiveIcon} text={mText} isActive={mIsActive} handleButtonClick={mHandleButtonClick} />
            </div>
            <div className="lover-app-gender-wrapper">
                <SelectButton icon={fIcon} activeIcon={fActiveIcon} text={fText} isActive={fIsActive} handleButtonClick={fHandleButtonClick} />
            </div>
        </div>
    )
}
